import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import AppcheckCredentialsForm from "./AppcheckCredentialsForm";
import AppcheckConfigListing from "./AppcheckConfigListing";

const AppcheckPullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={AppcheckCredentialsForm}
    PullConfigListingView={AppcheckConfigListing}
  />
);

export default AppcheckPullAndPushView;
